<template>
  <div class="index">
    <div class="gd">
      <div class="gd_d1">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/' }"
            >植物提取药</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ detail.Name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="gd_d2">
        <div class="gdd2_top">
          <div class="gdd2r_sp1">{{ detail.Name }}</div>
        </div>
        <div class="gdd2_bot">
          <div class="gdd2left_d1">
            <div class="gdd2leftd1_d1">
              <pic-zoom
                v-if="device !== 'mobile'"
                :url="addImgUrl(imgList[selectIndex])"
                :scale="3"
              ></pic-zoom>

              <img
                v-else
                class="gdd2leftd1_d1_mobile"
                :src="addImgUrl(imgList[selectIndex])"
              />
            </div>
          </div>
          <div class="gdd2left_d2">
            <div class="gdd2left_d2_left" @click="toLeft">
              <i class="el-icon-caret-left"></i>
            </div>
            <div class="gdd2left_d2_m">
              <div
                :style="'left:' + leftNum + 'px'"
                @mouseover="mouseOver(index)"
                :class="
                  'gdd2left_d2_m_d' +
                  (selectIndex == index ? ' gdd2left_d2_m_select' : '')
                "
                v-for="(item, index) in imgList"
                :key="index"
              >
                <img :src="addImgUrl(item)" />
              </div>
            </div>
            <div class="gdd2left_d2_left gdd2left_d2_right" @click="toRight">
              <i class="el-icon-caret-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="gd_d3">
        <div class="gdd3_right">
          <el-tabs
            v-model="activeName"
            type="border-card"
          >
            <el-tab-pane label="商品详情" name="1">
              <div v-html="DescInfo"></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div style="height: 20px"></div>
    </div>
    <div class="indexd3">
      <img src="../Home/img/图层49.png" />
    </div>
    <div class="index_d2">
      <div class="indexd2_top">
        <p>产品推荐</p>
      </div>
      <div class="indexd2_down">
        <div
          class="prolist"
          v-for="(item, index) in proList"
          :key="index"
          @click="toNCPDetail(item.id)"
        >
          <img class="pro_img" :src="addImgUrl(item.Pic)" />
          <div class="pro_text">{{ item.Intro }}</div>
          <div class="pro_pic">
            ￥<span>{{ item.Price }}</span>
          </div>
          <img class="pro_gwcimg" src="../Home/img/gouWuChe.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { addImgUrl } from "@/utils";
import PicZoom from "vue-piczoom";
export default {
  data() {
    return {
      num: 1,
      activeName: "1",
      leftNum: 0,
      selectIndex: 0,
      detail: "",
      DescInfo:'',
      id: "",
      imgList: [],
      imgsLength: 10,
      imgUrl: "",
      proList: [],
    };
  },
  components: {
    PicZoom,
  },
  computed: {
    ...mapGetters(["device"]),
  },
  watch: {},
  created: function () {
    if (typeof this.$route.query.id != "undefined") {
      this.id = this.$route.query.id;
      this.GetProductInfo();
    }
    this.GetNcpProductList();
  },
  mounted: function () {},
  methods: {
    addImgUrl,
    mouseOver(index) {
      this.selectIndex = index;
    },
    toDetail(id) {
      this.$router.push({
        path: "/goodsDetail",
        query: {
          id: id,
        },
      });
    },
    toNCPDetail(id) {
				this.$router.push({
					path: '/ncpgoodsdetail',
					query: {
						id: id
					}
				});
		},
    async GetNcpProductList() {
      let res = await this.$post("GetNcpProductList", {
        pageSize: 4,
      });
      console.log(res, "proList");
      this.proList = res.data.ResultData;
      this.proList.forEach((pro) => {
        pro.Intro = this.truncate(pro.Intro, 15);
        console.log(pro.Intro);
      });
    },
    truncate(value, length) {
     if (!value || value.length <= length) {
       return value;
     }
     return value.slice(0, length) + "...";
    },
    async GetProductInfo() {
      let res = await this.$post("GetProductInfo", {
        //"userId": that.$store.state.userId,
        id: this.id,
      });
      console.log(res, "res");
      this.detail = res.data.ResultData[0];
      this.DescInfo=res.data.ResultData[0].DescInfo.replace(/&lt;/g, '<').replace(/&gt;/g, '>');;
      console.log(this.DescInfo);
      this.imgList = res.data.ResultData[0].Pic.split(",");
    },
    
    toLeft() {
      if (this.imgList.length < 4) {
        return;
      }
      if (this.leftNum / 83.8 >= 0) {
        return;
      }
      if (-(this.leftNum / 83.8 + 4) < 0) {
        var num = parseInt(this.leftNum / 83.8 + 4);
        this.leftNum += 83.8 * num;
        return;
      }
      this.leftNum += 83.8 * 4;
    },
    toRight() {
      if (this.imgList.length < 4) {
        return;
      }
      if (-(this.leftNum / 83.8 - 8) > this.imgsLength) {
        var num = this.leftNum / 83.8 - 4 + this.imgsLength;
        this.leftNum -= 83.8 * num;
        return;
      }
      if (this.leftNum / 83.8 - 4 <= -this.imgsLength) {
        return;
      }
      this.leftNum -= 83.8 * 4;
    },
    handleChange(value) {
      console.log(value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped >
.index {
  width: 100%;
  background-image: url("../Home/img/组17.png");
  background-size: cover;
  /* 调整背景图片的尺寸，以填充整个容器 */
  background-position: center;
}
.gd {
  width: 1200px;
  margin: 0px auto;
}

.gd_d1 {
  width: 90%;
  padding: 25px 0 13px;
  box-sizing: border-box;
  border-bottom: 1px solid #dedede;
  margin-bottom: 15px;
}

.gd_d2 {
  width: 90%;
  margin: 0px auto;
  background-color: white;
}

.gdd2_top {
  display: flex;
  text-align: center;
}

.gdd2left_d1 {
  width: 420px;
  height: 420px;
  box-sizing: border-box;
  border: 1px solid #dedede;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

.gdd2leftd1_d1 {
  width: 410px;
  height: 410px;
  overflow: hidden;
}

.gdd2leftd1_d1 img {
  width: 410px;
  height: 410px;
}

.gdd2left_d2 {
  width: 410px;
  height: 75px;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  margin: auto;
  background-color: #f8f8f8;
}

.gdd2left_d2_left {
  width: 18px;
  height: 75px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.8;
}

.gdd2left_d2_m {
  width: 400px;
  height: 75px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.gdd2left_d2_m div {
  margin-left: 8.8px;
  width: 75px;
  height: 75px;
  border-width: 2px;
  border-style: solid;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: left 0.6s;
}

.gdd2left_d2_m img {
  width: 71px;
  height: 71px;
}

.gdd2r_sp1 {
  width: 100%;
  font-size: 24px;
  color: #333333;
  box-sizing: border-box;
  border-bottom: 1px dashed #dddddd;
  padding: 0 0 10px 15px;
}
.gd_d3 {
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 55px auto;
  background-color: white;
}
.gdd3_right {
  width: 100%;
}
.indexd3 {
  width: 100%;
  margin-top: 50px;
}
.indexd3 img {
  width: 100%;
}

.index_d2 {
  width: 100%;
}
.indexd2_top{
  margin: 0 auto;
  width: 465px;
  height: 100px;
  margin-top: 50px;
  background-image: url("../Home/img/图层44.png");
  background-size: 100% 100%;
  text-align: center;
  line-height: 100px;
  letter-spacing: 20px;
  font-size: 36px;
  font-family: "SimSun", "STSong", serif;
  font-weight: bold;
  color: white;
}
.indexd2_top p{
  margin-left: 40px;
}
.indexd2_down{
  width: 60%;
  margin: 0 auto;
  margin-top: 50px;
  display: flex;
}
.prolist{
  border: 2px solid #ccc;
  margin: 15px;
  background-color: white;
  padding: 10px 20px;
}
.pro_img{
  width: 200px;
}
.pro_text{
  font-size:0.8em;
  
}
.pro_pic{
  color: red;
  margin-top: 15px;
  float: left;
}
.pro_pic span{
  font-size: 1.5em;
}
.pro_gwcimg{
  height: 25px;
  width: 25px;
  margin-top: 20px;
  float: right;
}
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>